// Provider registry: the only place that knows which concrete class backs each interface.

import { config } from '../config';
import { DefaultBasemaps } from './basemaps';
import { OpenAipSource } from './openaip';
import { OpenMeteoWindSource } from './openmeteo';
import { PhotonGeocoder } from './photon';
import { TerrariumSource } from './terrarium';
import type { AirspaceSource, BasemapSource, GeocoderSource, TerrainSource, WindSource } from './types';

export function createTerrainSource(c = config.terrain): TerrainSource {
  switch (c.provider) {
    case 'terrarium':
      return new TerrariumSource(c.url, c.maxzoom, c.attribution);
  }
}

export function createWindSource(): WindSource {
  switch (config.wind.provider) {
    case 'open-meteo':
      return new OpenMeteoWindSource(config.apiBase);
  }
}

export function createAirspaceSource(): AirspaceSource {
  switch (config.airspace.provider) {
    case 'openaip':
      return new OpenAipSource(config.apiBase, config.airspace.tileZoom);
  }
}

export function createGeocoder(): GeocoderSource {
  switch (config.geocoder.provider) {
    case 'photon':
      return new PhotonGeocoder(config.apiBase);
  }
}

export function createBasemaps(): BasemapSource {
  switch (config.basemaps.provider) {
    case 'default':
      return new DefaultBasemaps();
  }
}

let terrain: TerrainSource | undefined;
let wind: WindSource | undefined;
let airspace: AirspaceSource | undefined;
let geocoder: GeocoderSource | undefined;
let basemaps: BasemapSource | undefined;

/** Lazily-created shared instances for the main thread. */
export const sources = {
  get terrain() {
    return (terrain ??= createTerrainSource());
  },
  get wind() {
    return (wind ??= createWindSource());
  },
  get airspace() {
    return (airspace ??= createAirspaceSource());
  },
  get geocoder() {
    return (geocoder ??= createGeocoder());
  },
  get basemaps() {
    return (basemaps ??= createBasemaps());
  },
};
